let loader;
let button;

let handleLoadedMore = (event) => {
    document.removeEventListener("loaded-more", handleLoadedMore);
    button.blur();
    if (true === event.detail['hasMore']) {
        loader.removeAttribute('hidden');
        loader.removeAttribute('aria-hidden');
        loader.removeAttribute('style');
        button.removeEventListener('click', handleClick);
        button.addEventListener('click', handleClick);
        if ('true' === button.getAttribute('aria-disabled')) {
            console.log('stop loading');
            button.dispatchEvent(new CustomEvent('stop-loading'));
            button.setAttribute('data-page', event.detail.page);
            button.setAttribute('aria-disabled', 'false');
        }
    } else {
        loader.setAttribute('hidden', 'hidden');
        loader.setAttribute('aria-hidden', 'true');
        button.setAttribute('aria-disabled', 'false');
        loader.setAttribute('style', 'display:none');
    }
}

let handleClick = () => {
    if ('true' !== button.getAttribute('aria-disabled')) {
        button.dispatchEvent(new CustomEvent('start-loading'));
        let page = button.getAttribute('data-page') ?? 1;
        button.setAttribute('aria-disabled', 'true');
        document.dispatchEvent(new CustomEvent('load-more', { detail: { page: parseInt(page) + 1 } }));
        document.addEventListener("loaded-more", handleLoadedMore);
    }
}

let init = () => {
    loader = document.querySelector('.js-articles-load-more');
    if (loader) {
        button = loader.querySelector('button');
        if (button !== undefined) {
            button.addEventListener('click', handleClick);
        }
    }
}

document.addEventListener("DOMContentLoaded", init);
document.addEventListener("masonry-load", init);
